import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import LinkPrimaryButton from '../ui/LinkPrimaryButton';

const { FiZap } = FiIcons;

export default function Navbar() {
  const location = useLocation();
  const isAuthPage = location.pathname === '/auth';

  return (
    <nav className="bg-white border-b border-slate-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2">
              <div className="bg-blue-600 p-2 rounded-lg">
                <SafeIcon icon={FiZap} className="h-5 w-5 text-white" />
              </div>
              <span className="font-bold text-xl tracking-tight text-slate-900">SwitchFree</span>
            </Link>
          </div>

          {!isAuthPage && (
            <div className="flex items-center gap-6">
              <Link to="/how-it-works" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
                How it Works
              </Link>
              <Link to="/auth" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
                Log in
              </Link>
              <LinkPrimaryButton to="/dashboard">
                Get Started
              </LinkPrimaryButton>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}